import { Component, Output, EventEmitter, ChangeDetectionStrategy, Input } from '@angular/core';
import { DatatableFooterDirective } from './footer.directive';
import { DataTablePagerComponent } from './pager.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
@Component({
    selector: 'datatable-footer',
    template: `
      <div
        class="datatable-footer-inner"
        role="row"
        [ngClass]="{ 'selected-count': selectedMessage }"
        [style.height.px]="footerHeight">
        @if (footerTemplate) {
          <ng-template [ngTemplateOutlet]="footerTemplate.template"
                       [ngTemplateOutletContext]="{
          rowCount: rowCount,
          pageSize: pageSize,
          selectedCount: selectedCount,
          curPage: curPage,
          offset: offset
        }" />
        }
        @if (!footerTemplate) {
          <div role="cell" class="page-count">
            @if (selectedMessage) {
              <span> {{ selectedCount?.toLocaleString() }} {{ selectedMessage }} / </span>
            }
            {{ rowCount?.toLocaleString() }} {{ totalMessage }}
          </div>
        }
        @if (!footerTemplate) {
          <datatable-pager role="cell"
                           [pagerLeftArrowIcon]="pagerLeftArrowIcon"
                           [pagerRightArrowIcon]="pagerRightArrowIcon"
                           [pagerPreviousIcon]="pagerPreviousIcon"
                           [pagerNextIcon]="pagerNextIcon"
                           [page]="curPage"
                           [size]="pageSize"
                           [count]="rowCount"
                           [hidden]="!isVisible"
                           (change)="page.emit($event)" />
        }
      </div>
    `,
    host: {
        class: 'datatable-footer',
        '[attr.role]': `'rowgroup'`
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, NgTemplateOutlet, DataTablePagerComponent]
})
export class DataTableFooterComponent {
  @Input() footerHeight: number | 'auto';
  @Input() rowCount: number;
  @Input() pageSize: number;
  @Input() offset: number;
  @Input() pagerLeftArrowIcon: string;
  @Input() pagerRightArrowIcon: string;
  @Input() pagerPreviousIcon: string;
  @Input() pagerNextIcon: string;
  @Input() totalMessage: string;
  @Input() footerTemplate: DatatableFooterDirective;

  @Input() selectedCount: number = 0;
  @Input() selectedMessage: string | boolean;

  @Output() page: EventEmitter<any> = new EventEmitter();

  get isVisible(): boolean {
    return this.rowCount / this.pageSize > 1;
  }

  get curPage(): number {
    return this.offset + 1;
  }
}
